import { combineReducers } from 'redux'
import actionTypes from 'constants/actionTypes'
import auth from './auth'
import graph from './graph'
import pendingActions from './pendingActions'
import bookmarks from './bookmarks'
import errors from './errors'
import localIds from './localIds'
import loggingOut from './loggingOut'
import { loggedIn } from 'lib/reducer'
import offline from './offline'
import confirm from './confirm'
import users from './users'
import permissions from './permissions'
import socket from './socket'
import prompt from './prompt'
import contentGeneration from './contentGeneration'
import graphQuery from './graphQuery'


const appReducer = combineReducers({
  auth: loggedIn(auth),
  graph: loggedIn(graph),
  errors: loggedIn(errors),
  confirm: loggedIn(confirm),
  pendingActions: loggedIn(pendingActions),
  bookmarks: loggedIn(bookmarks),
  localIds: loggedIn(localIds),
  loggingOut,
  offline,
  users: loggedIn(users),
  permissions: loggedIn(permissions),
  socket: socket,
  prompt: prompt,
  contentGeneration: contentGeneration,
  graphQuery: graphQuery
})

interface RootReducerAction {
  type: string
  [key: string]: unknown
}

const rootReducer = (state: unknown, action: RootReducerAction) => {
  if (action.type === actionTypes.RESET) return appReducer(undefined, action)
  return appReducer(state as never, action as never)
}

export default rootReducer
